<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input
        v-model="tableParams.searchKey"
        clearable

        style="width: 300px"
        placeholder="广告名称或应用名称或广告位编号或包名"
      />
      <search-channel-select
        v-model="tableParams.channelId"
        :channelType="100"
      />
      <search-slot-Type-select v-model="tableParams.slotTypeId" />
      <el-select
        v-model="tableParams.sizeId"
        clearable
        @change="change"

        placeholder="请选择广告位尺寸"
        :style="tableParams.sizeId === 0 ? 'width: 80px;' : 'width: 220px;'"
      >
        <el-option
          v-for="item in slotSizeList"
          :label="item.slotSize"
          :value="item.sizeId"
          :key="item.sizeId"
        />
      </el-select>
      <el-input
        v-if="tableParams.sizeId == 0"
        v-model="tableParams.customizeSize"

        placeholder="请输入您的广告位尺寸"
        style="margin-left: 2%; width: 200px"
      />
      <el-select
        v-model="tableParams.isEnable"
        clearable

        placeholder="审核状态"
        style="margin-right: 15px; width: 110px"
      >
        <el-option
          v-for="item in statusList"
          :label="item.lable"
          :value="item.value"
          :key="item.value"
        />
      </el-select>
      <search-settlement-Type-select
        style="margin-right: 15px; width: 110px"
        v-model="tableParams.settlementType"
      />
      <el-select
        v-model="tableParams.appType"
        clearable
        placeholder="请选择设备类型"

        style="margin-right: 50px"
      >
        <el-option
          v-for="item in appTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="tableParams.isDelete"
        clearable
        placeholder="请选择删除状态"

        style="margin-right: 50px"
      >
        <el-option :value="0" label="未删除"></el-option>
        <el-option :value="1" label="已删除"></el-option>
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button @click="handleBatchAudit" type="success" size="mini">
          批量审核
        </el-button>
        <el-upload
          :action="$baseURL + 'slot/import'"
          :headers="header"
          :show-file-list="false"
          :on-progress="onLoading"
          :on-success="onSuccess"
        >
          <el-button
            v-loading.fullscreen.lock="loading"
            type="primary"
            size="mini"
            style="margin: 0 10px"
            >批量新增</el-button
          >
        </el-upload>
        <el-button
          @click="downExcel('/slot/template', '渠道广告位模板')"
          type="warning"
          size="mini"
          >下载模板</el-button
        >
        <el-button
          @click="downExcelCSV('/slot/channel/csv', '渠道广告位', tableParams)"
          type="warning"
          size="mini"
          >导出</el-button
        >
        <el-button @click="add" type="primary" size="small">新增</el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        @selection-change="handleTableSelectionChange"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        ref="table"
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :sortable="v.field === 'updateTime'"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <span v-if="v.field === 'settlementType'">{{
              settlementTypeMap[scope.row[v.field]] || "-"
            }}</span>
            <span v-else-if="v.field === 'slotTypeId'">{{
              slotTypeMap[scope.row[v.field]] || "-"
            }}</span>
            <span v-else-if="v.field === 'sizeId'">{{
              scope.row["customizeSize"] || scope.row["slotSize"]
            }}</span>
            <span v-else-if="v.field === 'isEnable'">{{
              statusMap[scope.row[v.field]] || "-"
            }}</span>
            <template v-else-if="v.field === 'budgetNameIdList'">
              <el-popover placement="top-start" trigger="hover" ref="popover">
                <template #reference>
                  <span>查看</span>
                </template>
                <div>
                  {{
                    scope.row[v.field]
                      ? scope.row[v.field]
                          .map((item) => {
                            return item.budgetName;
                          })
                          .join("，")
                      : "-"
                  }}
                </div>
              </el-popover>
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="编辑" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button
              @click="update(scope.row)"
              type="success"
              :disabled="scope.row.isEnable == 0"
              size="mini"
              >编辑</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="250">
          <template v-slot="scope" align="center">
            <el-button
              @click="handleAudit(scope.row)"
              type="success"
              size="mini"
              >审核</el-button
            >
            <el-button @click="toPage(scope.row)" type="primary" size="mini"
              >流量配置</el-button
            >
            <el-button
              @click="isDanger(scope.row.slotId)"
              type="danger"
              size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>

    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="dialogClose"
      title="广告位审核"
      :width="500"
      append-to-body
    >
      <el-form ref="form" label-width="90px">
        <el-form-item label="广告名称">
          <el-tag
            v-for="(item, index) in auditForm.slotId"
            @close="deleteAppId(index)"
            :key="item.sizeId"
            :closable="auditForm.slotId.length > 1"

            style="margin-right: 10px"
          >
            {{ item.slotName }}
          </el-tag>
        </el-form-item>
        <el-form-item label="审核描述">
          <el-input
            v-model="auditForm.audit"
            type="textarea"

            placeholder="审核描述"
          />
        </el-form-item>
      </el-form>

      <div style="text-align: right">
        <el-button @click="auditSubmit(1)" type="warning"
          >审核不通过</el-button
        >
        <el-button @click="auditSubmit(0)" type="primary"
          >审核通过</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-model="dangerDialog"
      :close-on-click-modal="false"
      @close="dialogClose2"
      title="删除渠道广告位"
      :width="400"
      append-to-body
    >
      <div style="text-align: center; margin-bottom: 20px">
        你确认删除该条渠道广告位吗？
      </div>
      <div style="text-align: center">
        <el-button
          @click="dialogClose2"
          type="warning"

          style="margin-right: 20px"
          >取消</el-button
        >
        <el-button @click="dialogSubmit" type="primary"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <m-form @submit="toQuery" ref="form" />
  </div>
</template>

<script>
import SearchChannelSelect from "@/components/SearchChannelSelect";
import SearchSlotTypeSelect from "@/components/SearchSlotTypeSelect";
import SearchSettlementTypeSelect from "@/components/SearchSettlementTypeSelect";
import TableColumn from "@/components/TableColumn";
import initTableMixin from "@/mixins/initTable";
import { settlementTypeMap } from "@/const/settlement-type";
import { slotTypeMap } from "@/const/slot-type";
import { audit, upSlotStatus } from "@/api/advertise/flow";
import { getSlotSize } from "@/api/select";
import { hot } from "@/api/hot";
import { mapGetters } from "vuex";
import { downExcelMixin } from "@/mixins/downExcel";
import { appTypeList } from "@/const/app-type";
import mForm from "./form";

export default {
  name: "Flow",
  components: {
    SearchChannelSelect,
    SearchSlotTypeSelect,
    SearchSettlementTypeSelect,
    TableColumn,
    mForm,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      slotTypeMap,
      settlementTypeMap,
      appTypeList,
      tableParams: {},
      columns: [
        { field: "slotId", title: "广告位编号" },
        { field: "slotName", title: "广告名称" },
        { field: "channelName", title: "渠道名称" },
        { field: "appName", title: "应用名称" },
        { field: "appBundle", title: "包名" },
        { field: "lowPrice", title: "结算价格（分）" },
        { field: "settlementType", title: "结算方式" },
        { field: "slotTypeId", title: "广告位类型" },
        { field: "appType", title: "设备类型" },
        { field: "sizeId", title: "广告位尺寸" },
        { field: "isEnable", title: "审核状态" },
        { field: "updateTime", title: "修改时间" },
        { field: "budgetNameIdList", title: "预算" },
      ],
      statusMap: {
        0: "审核通过",
        1: "未通过",
        2: "未审核",
      },
      dialogStatus: false,
      auditForm: {
        slotId: [],
        audit: undefined,
      },
      slotSizeList: [],
      statusList: [
        { value: 0, lable: "审核通过" },
        { value: 1, lable: "未通过" },
        { value: 2, lable: "未审核" },
      ],
      pageshow: true,
      defaultList: true,
      header: {},
      loading: false,
      dangerDialog: false,
      slotId: undefined,
    };
  },
  created() {
    this.getSlotSize();
    this.header = {
      Authorization: "Bearer " + this.access_token,
    };
  },
  mounted() {
    if (localStorage.getItem("pagination")) {
      this.pagination = JSON.parse(localStorage.getItem("pagination"));
      this.tableParams = JSON.parse(localStorage.getItem("tableParams"));
      this.init();
      localStorage.removeItem("pagination");
      localStorage.removeItem("tableParams");
    } else {
      this.init();
    }
  },
  computed: {
    ...mapGetters(["access_token"]),
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/slot/flowManage/slotFlowSet";
      return true;
    },
    getSlotSize() {
      getSlotSize().then((res) => {
        if (res.code === 200) {
          this.slotSizeList = res.data;
          this.slotSizeList.unshift({ sizeId: 0, slotSize: "其它" });
        }
      });
    },
    handleAudit(row) {
      this.dialogStatus = true;
      this.auditForm.slotId = [row];
      this.auditForm.audit = row.reason;
    },
    handleTableSelectionChange(selection) {
      this.tableSelect = selection;
    },
    handleBatchAudit() {
      this.dialogStatus = true;
      this.auditForm.slotId = this.tableSelect;
    },
    auditSubmit(status) {
      const form = [];
      this.auditForm.slotId.forEach((item) => {
        const obj = {
          audit: this.auditForm.audit || undefined,
          isEnable: status,
          slotId: item.slotId,
        };
        form.push(obj);
      });
      audit(form).then((res) => {
        if (res.code === 200) {
          this.resetForm();
        }
      });
    },
    resetForm() {
      this.auditForm = {
        slotId: [],
        audit: undefined,
      };
      this.$refs.table.clearSelection();
      this.init();
      this.dialogStatus = false;
    },
    deleteAppId(index) {
      this.auditForm.slotId.splite(index, 1);
    },
    dialogClose() {
      this.dialogStatus = false;
    },
    toPage(row) {
      localStorage.setItem("pagination", JSON.stringify(this.pagination));
      localStorage.setItem("tableParams", JSON.stringify(this.tableParams));
      localStorage.setItem("slotId", JSON.stringify(row.slotId));
      this.$router.push({
        path: "flow/config",
      });
    },
    add() {
      this.$refs.form.show();
    },
    update(row) {
      this.$refs.form.show(row);
    },
    change(item) {
      let data = {
        maker: "slotSizeOnThe",
        onTheOrderId: item,
      };
      if (item) {
        hot(data);
      }
    },
    onLoading() {
      this.loading = true;
    },
    onSuccess() {
      this.loading = false;
      this.$message({
        message: "已成功导入",
        type: "success",
      });
    },
    isDanger(id) {
      this.dangerDialog = true;
      this.slotId = id;
    },
    dialogSubmit() {
      let state = {
        slotId: this.slotId,
        slotStatus: 1,
      };
      upSlotStatus(state)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "删除状态改变成功",
              type: "success",
            });
          }
        })
        .finally(() => {
          this.dialogClose2();
          this.init();
        });
    },
    dialogClose2() {
      this.dangerDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  & > * {
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;
  .table__operation {
    padding-bottom: 10px;
  }
}
.el-pagination {
  text-align: right;
}
</style>
